import React from "react";
import {FormControl, ControlLabel} from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import Immutable from "immutable";

export default class SpecialBillForm extends React.Component {
    constructor(props) {
        super(props);   
        this.state = {
            taskDetails : []
        }

        this.setValue = this.setValue.bind(this);
        this.getValues = this.getValues.bind(this);
        this.validate = this.validate.bind(this);
    }

    updateList(taskCode) {
        const self = this;
        const clone = Immutable.fromJS(this.state).toJS();
        
        if (taskCode && taskCode.length > 0) {
            let url = `get-placement-task-details-with-spb/${self.props.assignId}/${self.props.offSysId}/${taskCode}`;
            if (self.props.timecardLineDetailId > 0)
                url = url + `/${self.props.timecardLineDetailId}`;

            ajax.api()
                .get(url)
                .then(function(res) {
                    let data = res.data;
                    clone.taskDetails = data;
                    self.setState(clone, function(){
                        for(let i=0; i<clone.taskDetails.length; i++) {
                            this.setValue(
                                clone.taskDetails[i].taskCode
                                , clone.taskDetails[i].specialBillValue);
                        }
                    });
                })
                .catch(function(err) {
                    let data = err.response? err.response.data: err;
                    context.message({
                        show: true,
                        type:"error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                });        
        } else {
            clone.taskDetails = [];
            self.setState(clone);
        }
    }

    getValues() {
        return this.state.taskDetails;
    }

    setValue(taskCode, value) {
        for (let i=0; i<this.state.taskDetails.length; i++) {
            const td = this.state.taskDetails[i];
            if (td.taskCode === taskCode) {
                td.specialBillValue = value;
                break;
            }
        }
    }

    validate() {
        for (let i=0; i<this.state.taskDetails.length; i++) {
            const ptd = this.state.taskDetails[i];
            if (ptd && ptd.required && (ptd.specialBillValue == null || ptd.specialBillValue.trim().length == 0)) {
                return "Special Bill is required";
            }
        }
        return null;
    }

    render() {
        let content = null;
        if (this.state.taskDetails && this.state.taskDetails.length > 0) {
            let picklist = this.state.taskDetails.map(td => {
                let control = td.pickList == null || td.pickList.length == 0 || td.placementTaskDetailId == 0?
                            <FormControl type="text" 
                                defaultValue={td.specialBillValue} 
                                onChange={(evt) => this.setValue(td.taskCode, evt.target.value)}
                                disabled={td.placementTaskDetailId == 0} />
                        : 
                            <FormControl componentClass="select"
                                defaultValue={td.specialBillValue}
                                onChange={(evt) => this.setValue(td.taskCode, evt.target.value)}>
                                <option key="" value="">Please select...</option>
                                {td.pickList.map(pl => <option key={pl.taskValue} value={pl.taskValue}>{pl.taskValue}</option>)}
                            </FormControl>;

                return (
                    <div className="row" key={Math.random()}>
                        <div className="col-md-2">
                            <ControlLabel>{td.taskCode} {td.required? <span className="ap-color-red">*</span>: <span></span>}</ControlLabel>
                        </div>
                        <div className="col-md-10"> 
                            {control}
                        </div>
                    </div>
                );
        });
            content = (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <hr />
                            <span className="ap-h3">Special Bill</span>
                        </div>
                        <div className="col-md-12 ap-top-margined">&nbsp;</div>
                    </div>                          
                    {picklist}
                </div>
                );
        }
        return(
            <div>
                {content}
            </div>
            );
    }
}